import { render, staticRenderFns } from "./QuestionLayoutF.vue?vue&type=template&id=3409f444&scoped=true&"
import script from "./QuestionLayoutF.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutF.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutF.vue?vue&type=style&index=0&id=3409f444&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3409f444",
  null
  
)

export default component.exports